import styled from "styled-components";

export const Container = styled.div`
  font-family: "Merriweather", serif;
  font-weight: 300;
  line-height: 150%;
  max-width: 1090px;
  margin: 20px auto 80px;
  padding: 10px;

  a {
    text-decoration: none;
    color: #096dd9;
    font-size: 1rem;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      orphans: 3;
      widows: 3;
    }

    li::before {
      content: "•";
      color: rgba(0, 0, 0, 0.2);
      margin-left: -18px;
      padding-right: 8px;
    }
  }

  .bold {
    font-weight: 600;
  }

  @media screen and (max-width: 720px) {
    padding: 12px;
    margin: 10px auto 80px;
  }
`;

export const DownloadButton = styled.button`
  padding: 0.3rem 1.2rem;
  border: solid 1px var(--color-dark);
  border-radius: 0.4rem;
  background-color: transparent;
  opacity: 0.3;
  margin: 30px 16px 30px;

  transition: 350ms ease;
  cursor: pointer;

  &:hover {
    background-color: var(--color-dark);
    color: var(--color-light);
    opacity: 1;
  }

  @media screen and (max-width: 720px) {
    margin: 0 16px 20px;
  }
`;

export const BioInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;
  border-radius: 20px;
  background-color: rgba(236, 236, 236, 0.3);

  h1 {
    font-family: "Merriweather", serif;
    font-size: 2.4rem;
    width: 256px;
    line-height: 160%;
    opacity: 0.9;
  }

  div {
    margin: 8px 0;
  }
`;

export const Skills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 10px;
  margin-left: -3px;
  font-size: 14px;

  p {
    margin: 0;
    padding: 0 10px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
  }
`;

export const Section = styled.section`
  display: flex;

  em {
    color: red;
    font-style: normal;
    opacity: 0.8;
  }

  b {
    opacity: 0.76;
  }

  @media screen and (max-width: 720px) {
    flex-wrap: wrap;
  }
`;

export const SectionHeader = styled.div`
  min-width: 256px;

  img {
    margin-left: 4px;
    opacity: 0.2;
  }

  a {
    color: #0080ff;
  }

  .bold {
    opacity: 0.76;
  }

  @media screen and (max-width: 720px) {
    min-width: 100%;
    margin-bottom: 14px;
  }
`;

export const Article = styled.article`
  padding: 20px 30px;
  border-radius: 20px;
  background-color: rgba(236, 236, 236, 0.3);
  margin: 16px 0;
  display: flex;
  gap: 32px;
  flex-direction: column;
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  opacity: 0.4;
  text-transform: uppercase;
  margin-bottom: -10px;
`;
